// Firebase CDN Bundle Entry Point

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  connectFirestoreEmulator,
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";

// Named exports
export {
  // Core
  initializeApp,
  // Firestore
  getFirestore,
  connectFirestoreEmulator,
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  // Analytics
  getAnalytics,
  isSupported,
  logEvent,
  // Auth
  getAuth,
  connectAuthEmulator,
};

// Default export (compat)
export default {
  initializeApp,
  getFirestore,
  connectFirestoreEmulator,
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  deleteDoc,
  doc,
  serverTimestamp,
  getAnalytics,
  isSupported,
  logEvent,
  getAuth,
  connectAuthEmulator,
};
